// DO NOT set the `name` and `ticker` properties manually
// Instead use one of the get token metadata scripts https://github.com/ExodusMovement/exodus-core/tree/master/packages/assets-base#get-token-metadata

export default [
  {
    name: 'aave_matic_bfdf3c37',
    displayName: 'Aave',
    decimals: 18,
    ticker: 'AAVEmaticBFDF3C37',
    displayTicker: 'AAVE',
    addresses: {
      current: '0xD6DF932A45C0f255f85145f286eA0b292B21C90B',
    },
    primaryColor: '#9391F7',
    gradientColors: ['#9391F7', '#B2B1FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '20%', y2: '20%' },
  },
  {
    name: 'blok_matic_79cb78bc',
    displayName: 'Bloktopia',
    decimals: 18,
    ticker: 'BLOKmatic79CB78BC',
    displayTicker: 'BLOK',
    addresses: { current: '0x229b1b6C23ff8953D663C4cBB519717e323a0a84' },
    info: {
      description:
        'The BLOK token allows holders to access Bloktopia, a metaverse featuring an ever-changing skyscraper where users can learn about crypto, play games, purchase items, earn real estate revenue, attend events, and more.',
      reddit: '',
      twitter: 'https://twitter.com/bloktopia',
      website: 'https://www.bloktopia.com/',
      telegram: '',
    },
    primaryColor: '#FF47FF',
    gradientColors: ['#AC18AC', '#FF47FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'dai_matic_845af41b',
    displayName: 'DAI',
    decimals: 18,
    ticker: 'DAImatic845AF41B',
    displayTicker: 'DAI',
    addresses: { current: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063' },
    primaryColor: '#f6b048',
    gradientColors: ['#FBCC5F', '#F9A606'],
    gradientCoords: { x1: '3.912%', y1: '0%', x2: '89.933%', y2: '100%' },
  },
  {
    name: 'ghst_matic_d2b95a36',
    displayName: 'Aavegotchi',
    decimals: 18,
    ticker: 'GHSTmaticD2B95A36',
    displayTicker: 'GHST',
    addresses: { current: '0x385Eeac5cB85A38A9a07A70c73e0a3271CfB54A7' },
    info: {
      description:
        'GHST is the in-game currency and governance token for Aavegotchi, an open-source NFT gaming platform. Aavegotchis are characters that need pet-like attention, and gamers get rewarded for caring for them.',
      reddit: 'https://reddit.com/r/Aavegotchi',
      twitter: 'https://twitter.com/aavegotchi',
      website: 'https://aavegotchi.com/',
      telegram: 'https://t.me/Aavegotchi',
    },
    primaryColor: '#FA34F3',
    gradientColors: ['#FA34F3', '#8F17F9'],
    gradientCoords: { x1: '3%', y1: '8.5%', x2: '41.044%', y2: '23.738%' },
  },
  {
    name: 'gns_matic_4ae7a3c1',
    displayName: 'Gains Network',
    decimals: 18,
    ticker: 'GNSmatic4AE7A3C1',
    displayTicker: 'GNS',
    addresses: { current: '0xE5417Af564e4bFDA1c483642db72007871397896' },
    info: {
      description:
        'GNS is a deflationary token that powers the Gains Network, a leveraged trading platform. The Gains Network ecosystem includes NFTs, staking pools, and more.',
      reddit: 'https://www.reddit.com/r/GainsNetwork/',
      twitter: 'https://twitter.com/GainsNetwork_io',
      website: 'https://gainsnetwork-io.medium.com/',
    },
    primaryColor: '#4DFC8D',
    gradientColors: ['#37BE96', '#4DFC8D'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'link_matic_0fc0671d',
    displayName: 'ChainLink',
    decimals: 18,
    ticker: 'LINKmatic0FC0671D',
    displayTicker: 'LINK',
    addresses: { current: '0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39' },
    primaryColor: '#3FA0F1',
    gradientColors: ['#3FA0F1', '#295ADA'],
    gradientCoords: { x1: '-22.982%', y1: '-43.915%', x2: '91.53%', y2: '101%' },
  },
  {
    name: 'mvx_matic_60b5e17b',
    displayName: 'Metavault Trade',
    decimals: 18,
    ticker: 'MVXmatic60B5E17B',
    displayTicker: 'MVX',
    addresses: { current: '0x2760E46d9BB43dafCbEcaad1F64b93207f9f0eD7' },
    info: {
      description:
        'MVX is the utility and governance token of Metavault.Trade, a decentralized exchange with low fees and a wide variety of trading features. Users can connect a private wallet so they never share their personal info.',
      twitter: 'https://twitter.com/MetavaultTrade',
      website: 'https://medium.com/@metavault.trade',
    },
    primaryColor: '#625CF4',
    gradientColors: ['#625CF4', '#9A96FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'sand_matic_0472de85',
    displayName: 'The Sandbox',
    decimals: 18,
    ticker: 'SANDmatic0472DE85',
    displayTicker: 'SAND',
    addresses: { current: '0xBbba073C31bF03b8ACf7c28EF0738DeCF3695683' },
    primaryColor: '#00ADEF',
    gradientColors: ['#0084FF', '#00ADEF'],
    gradientCoords: { x1: '9.954%', y1: '7.596%', x2: '34.509%', y2: '31.978%' },
  },
  {
    name: 'sportx_matic',
    displayName: 'SportX',
    decimals: 18,
    ticker: 'SXMATIC',
    displayTicker: 'SX',
    addresses: { current: '0x840195888Db4D6A99ED9F73FcD3B225Bb3cB1A79' },
    primaryColor: '#00CC77',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'stmatic_matic_bac42ee5',
    displayName: 'Lido Staked MATIC',
    decimals: 18,
    ticker: 'STMATICmaticBAC42EE5',
    displayTicker: 'stMATIC',
    addresses: { current: '0x3A58a54C066FdC0f2D55FC9C89F0415C92eBf3C4' },
    info: {
      description:
        'When someone stakes their MATIC with Lido, they receive stMATIC tokens and start earning rewards. Just like MATIC, stMATIC can be traded, used for payments, and used in DeFi.',
      website: 'https://polygon.lido.fi/',
      telegram: 'https://t.me/lidofinance',
    },
    primaryColor: '#00BAFF',
    gradientColors: ['#00BAFF', '#3ADCFF'],
    gradientCoords: { x1: '30%', y1: '-13.503%', x2: '-1.873%', y2: '-7.408%' },
  },
  {
    name: 'usdt_matic_86e249c1',
    displayName: 'Tether USD',
    decimals: 6,
    ticker: 'USDTmatic86E249C1',
    displayTicker: 'USDT',
    addresses: { current: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F' },
    primaryColor: '#53AE94',
    gradientColors: ['#53AE94', '#2E9175'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'usdc_matic_0a883d9b',
    displayName: 'USDC',
    decimals: 6,
    ticker: 'USDCmatic0A883D9B',
    displayTicker: 'USDC',
    addresses: { current: '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359' },
    info: {
      description:
        'USDC is a token designed as a stablecoin issued by Circle and Coinbase. Each unit of USDC is backed by a unit of US Dollar in audited bank accounts in order to ensure 1 USDC is always equal to 1 USD.',
      reddit: 'https://www.reddit.com/r/USDC/',
      twitter: 'https://twitter.com/centre_io',
      website: 'https://www.centre.io/usdc',
    },
    primaryColor: '#3E90E8',
    gradientColors: ['#3E90E8', '#2775CA'],
    gradientCoords: { x1: '102%', y1: '101%', x2: '0%', y2: '0%' },
  },
  {
    name: 'wbtc_matic_298d6ace',
    displayName: 'Wrapped Bitcoin',
    decimals: 8,
    ticker: 'WBTCmatic298D6ACE',
    displayTicker: 'WBTC',
    addresses: { current: '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6' },
    primaryColor: '#8958AB',
    gradientColors: ['#8958AB', '#3D2F52'],
    gradientCoords: { x1: '91.762%', y1: '69.532%', x2: '4.905%', y2: '24.223%' },
  },
  {
    name: 'weth_matic',
    displayName: 'Wrapped Ether',
    decimals: 18,
    ticker: 'WETHMATIC',
    displayTicker: 'WETH',
    addresses: { current: '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619' },
    primaryColor: '#FF58A2',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
]
